/* ============
 * Account Transformer
 * ============
 *
 * The transformer for the account.
 */

import Transformer from '../transformer';
import Picture from '../common/picture';

export default class EmbedUser extends Transformer {
  /**
   * Method used to transform a fetched account
   *
   * @param user The fetched user
   *
   * @returns {Object} The transformed account
   */
  static fetch(user) {
    return {
      email: user.email,
      firstName: user.firstname,
      lastName: user.lastname,
      gender: user.gender,
      phone: user.phone,
      mainPicture: user.main_picture ? Picture.fetch(user.main_picture) : null,
    };
  }
}
